<template>
	<v-select
		:filterable="false"
		:options="items"
		@search="searchItems"
		label="name"
		@input="emitItem"
		:value="value"
		:multiple="multiple"
		:placeholder="placeholder"
		:disabled="disabled"
	>
		<template slot="no-options">
			<span>Type to search items...</span>
		</template>
	</v-select>
</template>

<style scoped>
.height-limit {
	max-height: 2.5em;
	overflow: hidden;
	text-overflow: ellipsis;
}
.align-fix {
	margin-top: -3px;
}
</style>

<script>
import ItemService from "@/services/ItemService";
import fs from "@/services/FormatService";

export default {
	name: "ConfigItemSearch",

	props: {
		value: true,
		placeholder: true,
		contentAreaID: null,
		multiple: {
			type: Boolean,
			default: false
		},
		disabled: true
	},

	components: {},

	data() {
		return {
			fs: fs,
			items: []
		};
	},
	created() {},
	watch: {},
	computed: {},
	methods: {
		searchItems(search, loading) {
			loading(true);
			let ctx = {
				perPage: 8,
				currentPage: 1,
				active: true,
				filter: search
			};

			if (this.contentAreaID) {
				ctx.content_area_id = this.contentAreaID;
			}

			ItemService.listItems(ctx)
				.then(resp => {
					this.items = resp.data.items;

					loading(false);
				})
				.catch(err => {
					console.log(err);
					this.items = [{ name: "Error loading items" }];
				});
		},

		emitItem(item) {
			if (!item) {
				this.items = [];
			}
			this.$emit("input", item);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/ConfigItemSearch.vue